import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/predictive-analytics/page.tsx");
